import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import {GRAY_CLOSE_IMG} from 'src/defaultImages.js';
@Component({
  selector: 'app-reoccur-know-more',
  templateUrl: './reoccur-know-more.component.html',
  styleUrls: ['./reoccur-know-more.component.css'],
})
export class ReoccurKnowMoreComponent implements OnInit {
 @Input() showRazorText:boolean;
  images = {
    GRAY_CLOSE_IMG: GRAY_CLOSE_IMG,
  };
  
  constructor(
    private _modalRef: NzModalRef,
  ) {}

  ngOnInit() {}

  dismissModal() {
    this._modalRef.close();
  }

}
